/* upstack-remediation:2026-09-26 */
(() => {
  'use strict';
  if (window.UnchemedCommerce) return;
  const endpoint = 'https://fjyiwu8bhk.unchemed.com/sr';
  const selected = new Map();
  const bindings = new WeakMap();
  const attributionKeys = /^(utm_[a-z_]+|fbclid|gclid|ttclid|epik|clickid|ad_id|adset_id|campaign_id|tw_source|tw_adid)$/;
  let busy = false, redirectTimer = 0, activeForm = null;
  function attribution() {
    const params = new URLSearchParams();
    const merge = raw => new URLSearchParams(raw).forEach((v,k) => {if (attributionKeys.test(k) && v && v !== 'undefined') params.set(k,v);});
    try {
      const cookie = document.cookie.split(/;\s*/).find(x => x.startsWith('_landing_detail='));
      if (cookie) {
        const raw = decodeURIComponent(cookie.slice('_landing_detail='.length));
        merge(raw.includes('?') ? raw.slice(raw.indexOf('?') + 1) : raw);
      }
    } catch (_) {}
    try {merge(sessionStorage.getItem('unc:attribution') || '');} catch (_) {}
    merge(location.search);
    try {if (params.toString()) sessionStorage.setItem('unc:attribution',params.toString());} catch (_) {}
    return params;
  }
  const money = (cents,currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:currency || 'USD'}).format(cents/100);
  const compactMoney = cents => '$' + (cents/100).toLocaleString('en-US',{maximumFractionDigits:2});
  function config(form) {
    const script = form?.closest('[data-unc-buy]')?.querySelector('[data-coras-product]');
    if (!script) throw new Error('The product could not be loaded. Please refresh and try again.');
    const product = JSON.parse(script.textContent);
    if (!Array.isArray(product.variants)) throw new Error('The product could not be loaded. Please refresh and try again.');
    return product;
  }
  const variantFor = (product,id) => product.variants.find(v => String(v.id) === String(id));
  function text(root,selector,value) {const node = root.querySelector(selector); if (node) node.textContent = value;}
  function setBusy(state) {
    busy = state;
    document.querySelectorAll('form[data-coras-form]').forEach(form => {
      let product = null, variant = null;
      try {product = config(form); variant = variantFor(product,form.elements.id.value);} catch (_) {}
      form.querySelectorAll('input[type="radio"]').forEach(input => {input.disabled = state || !variantFor(product || {variants:[]},input.value)?.available;});
      [...document.querySelectorAll('button[type="submit"],input[type="submit"],[data-duo-submit]')].filter(button => button.form === form).forEach(button => {
        button.disabled = state || !variant?.available; button.setAttribute('aria-busy',String(state));
        const label = button.querySelector('[data-button-label]');
        if (label) label.textContent = state ? 'Opening checkout\u2026' : variant?.available ? 'Add to cart' : 'Sold out';
        else if (button.matches('[data-duo-submit]')) button.textContent = state ? 'Opening checkout\u2026' : variant?.available ? 'Add to cart \u2192' : 'Sold out';
      });
    });
    document.querySelectorAll('[data-coras-cart-checkout]').forEach(button => {button.disabled = state; button.setAttribute('aria-busy',String(state));});
  }
  function syncDuo(product,id,form) {
    const variant = variantFor(product,id);
    if (!variant) return;
    form.elements.id.value = String(variant.id);
    const options = [...form.querySelectorAll('input[type="radio"]')];
    options.forEach(input => {
      const item = variantFor(product,input.value);
      if (!item) {input.disabled = true; return;}
      input.checked = input.value === String(variant.id); input.disabled = busy || !item.available;
      const label = input.closest('.opt');
      if (!label) return;
      label.classList.toggle('on',input.checked);
      text(label,'.pp b',compactMoney(item.price)); text(label,'.pp s',compactMoney(item.compare));
      const count = Number(input.dataset.count);
      if (count > 1) text(label,'.info > span',compactMoney(item.price/count) + '/ea \u00b7 save ' + compactMoney(item.compare-item.price));
    });
    const count = Number(options.find(input => input.checked)?.dataset.count || 1), images = form.querySelector('.pimg');
    if (images) {
      const imageCount = images.dataset.singleImage === 'true' ? 1 : count;
      images.classList.toggle('q2',imageCount === 2); images.classList.toggle('q3',imageCount === 3);
      images.querySelectorAll('img').forEach((img,index) => img.classList.toggle('hide',index >= imageCount));
    }
    const sticky = document.getElementById('stick');
    if (sticky) {
      text(sticky,'#sname',(form.dataset.group === 'duo' ? 'System' : 'Kit') + ' \u00b7 ' + count);
      text(sticky,'#sprice',compactMoney(variant.price)); text(sticky,'s',compactMoney(variant.compare));
      const image = sticky.querySelector('img'), source = images?.querySelector('img');
      if (image && source) image.src = source.src;
      sticky.querySelector('button')?.setAttribute('form',form.getAttribute('id'));
    }
    text(form,'[data-cta-price]',compactMoney(variant.price));
    const summary = document.querySelector('[data-price-offer] .oprice');
    if (summary) {
      text(summary,'b',compactMoney(variant.price));
      const compare = summary.querySelector('s');
      if (compare) {compare.hidden = variant.compare <= variant.price;compare.textContent=compactMoney(variant.compare);}
      text(summary,'[data-active-offer-copy]',(form.dataset.group === 'duo' ? '20-Stage System' : '5-Stage Kit') + ' · ' + count + (count === 1 ? ' shower' : ' showers') + (variant.compare > variant.price ? ' · Save ' + compactMoney(variant.compare-variant.price) : ''));
    }
    selected.set('active',form.getAttribute('id'));
  }
  function sync(product,id,origin) {
    const variant = variantFor(product,id);
    if (!variant) return;
    if (origin.dataset.group) {syncDuo(product,id,origin); setBusy(busy); return;}
    selected.set(String(product.id),String(variant.id));
    document.querySelectorAll('form[data-coras-form]').forEach(form => {
      if (form.dataset.group || form.closest('[data-unc-buy]')?.dataset.uncBuy !== String(product.id)) return;
      form.elements.id.value = String(variant.id);
      form.querySelectorAll('input[type="radio"]').forEach(input => {
        input.checked = input.value === String(variant.id); input.closest('.unc-plan')?.classList.toggle('is-selected',input.checked);
      });
      text(form,'[data-price]',money(variant.price,product.currency));
      const compare = form.querySelector('[data-compare]'), discounted = variant.compare > variant.price;
      if (compare) {compare.hidden = !discounted; compare.textContent = discounted ? money(variant.compare,product.currency) : '';}
      text(form,'[data-saving]',discounted ? 'Save ' + money(variant.compare-variant.price,product.currency) : '');
    });
    document.querySelectorAll('[data-sticky-price]').forEach(node => {node.textContent = money(variant.price,product.currency);});
    if (product.handle?.includes('bundles')) {
      const index = product.variants.findIndex(v => String(v.id) === String(id));
      const thumb = document.querySelectorAll('.gal-thumbs .t')[index];
      if (thumb && typeof window.lpGal === 'function') window.lpGal(thumb);
    }
    setBusy(busy);
  }
  function payload(product,id) {
    const variant = variantFor(product,id);
    if (!variant?.available) throw new Error('This option is currently unavailable. Please choose another option.');
    const items = [{v:Number(variant.id),p:Number(product.id),q:1}];
    if (product.gift?.price === 0) items.push({v:Number(product.gift.variant),p:Number(product.gift.id),q:1});
    if (!items.every(item => Number.isSafeInteger(item.v) && item.v > 0 && Number.isSafeInteger(item.p) && item.p > 0)) throw new Error('The product could not be loaded. Please refresh and try again.');
    return {items};
  }
  function checkoutURL(raw) {
    const url = new URL(raw);
    if (url.protocol !== 'https:' || url.hostname !== 'checkouts.unchemed.com' || url.port || url.pathname === '/' || url.username || url.password) throw new Error('Checkout returned an unexpected link. Please try again.');
    return url.href;
  }
  async function fetchJSON(url,options,timeoutMs = 15000) {
    const abort = new AbortController(), timeout = setTimeout(() => abort.abort(),timeoutMs);
    try {
      const response = await fetch(url,{...options,signal:abort.signal});
      if (!response.ok) throw new Error('Checkout is temporarily unavailable. Please try again.');
      return await response.json();
    } finally {clearTimeout(timeout);}
  }
  async function requestCheckout(body,currency) {
    const url = new URL(endpoint), params = attribution();
    params.forEach((v,k) => url.searchParams.set(k,v));
    url.searchParams.set('spf_cur',currency || window.Shopify?.currency?.active || 'USD');
    const requestBody = params.toString() ? {...body,landing_page:'?' + params.toString()} : body;
    const data = await fetchJSON(url.href,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(requestBody)});
    if (!data || data.success === false || typeof data.url !== 'string') throw new Error('Checkout did not return a link. Please try again.');
    return checkoutURL(data.url);
  }
  function reportError(form,error) {
    const box = form?.querySelector('.unc-checkout-error');
    if (!box) return;
    box.textContent = error?.name === 'AbortError' ? 'The connection took too long. Please try again.' : error?.message || 'We could not open checkout. Please try again.';
    box.hidden = false;
  }
  function redirect(url,form) {
    activeForm = form; clearTimeout(redirectTimer);
    redirectTimer = setTimeout(() => {
      if (!document.hidden) {setBusy(false); reportError(form,new Error('Checkout did not open. Please try again.'));}
    },8000);
    window.location.assign(url);
  }
  function trackAccepted(product, id) {
    try { return Promise.resolve(window.UnchemedTracking?.cartAccepted?.(product, id)); }
    catch (_) { return Promise.resolve(false); }
  }
  async function finishTracking(tracking) {
    let timer;
    try { await Promise.race([tracking, new Promise(resolve => {timer = setTimeout(resolve, 750);})]); }
    catch (_) {} finally { clearTimeout(timer); }
  }
  async function submit(form) {
    if (busy) return;
    const errorBox = form.querySelector('.unc-checkout-error'); if (errorBox) errorBox.hidden = true;
    if (document.body.dataset.designMode === 'true') {reportError(form,new Error('Open the theme preview in a new tab to test checkout.')); return;}
    setBusy(true);
    try {
      const product = config(form), id = form.elements.id.value, body = payload(product,id);
      const url = await requestCheckout(body,product.currency);
      const tracking = trackAccepted(product,id);
      await finishTracking(tracking);
      redirect(url,form);
    } catch (error) {reportError(form,error); setBusy(false);}
  }
  async function submitCart(form,openCheckout) {
    if (busy) return;
    const errorBox = form.querySelector('.unc-checkout-error'); if (errorBox) errorBox.hidden = true;
    if (document.body.dataset.designMode === 'true') {reportError(form,new Error('Open the theme preview in a new tab to test checkout.')); return;}
    if (!form.reportValidity()) return;
    setBusy(true);
    try {
      const updates = new FormData(form); updates.delete('checkout'); updates.delete('update');
      const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/,'/');
      const cart = await fetchJSON(root + 'cart/update.js',{method:'POST',body:updates});
      if (!Array.isArray(cart.items)) throw new Error('We could not update your cart. Please try again.');
      const items = cart.items.map(item => ({v:item.variant_id,p:item.product_id,q:item.quantity}));
      if (!openCheckout || !items.length) {window.location.reload(); return;}
      if (!items.every(item => Number.isSafeInteger(item.v) && item.v > 0 && Number.isSafeInteger(item.p) && item.p > 0 && Number.isSafeInteger(item.q) && item.q > 0)) throw new Error('We could not update your cart. Please try again.');
      const url = await requestCheckout({items},cart.currency);
      redirect(url,form);
    } catch (error) {reportError(form,error); setBusy(false);}
  }
  function init(root = document) {
    root.querySelectorAll('form[data-coras-form]').forEach(form => {
      if (bindings.has(form)) return;
      bindings.set(form,true); form.dataset.bound = 'true';
      form.addEventListener('submit',event => {event.preventDefault(); submit(form);});
      form.addEventListener('change',event => {
        if (!event.target.matches('input[type="radio"]') || busy) return;
        try {sync(config(form),event.target.value,form);} catch (error) {reportError(form,error);}
      });
      try {
        const product = config(form), requested = new URLSearchParams(location.search).get('variant');
        const desired = form.dataset.group ? requested : selected.get(String(product.id)) || requested;
        const options = [...form.querySelectorAll('input[type="radio"]')];
        const available = input => variantFor(product,input.value)?.available;
        const first = options.find(input => input.value === desired && available(input)) || options.find(input => input.checked && available(input)) || options.find(available);
        if (first) sync(product,first.value,form); else setBusy(false);
      } catch (error) {reportError(form,error); setBusy(false);}
    });
    const requested = new URLSearchParams(location.search).get('variant');
    const target = [...document.querySelectorAll('form[data-coras-form][data-group]')].find(form => [...form.querySelectorAll('input[type="radio"]')].some(input => input.value === requested && input.checked));
    const defaultForm = target || document.getElementById('unc-duo-form');
    if (defaultForm) {try {sync(config(defaultForm),defaultForm.elements.id.value,defaultForm);} catch (error) {reportError(defaultForm,error);}}
    root.querySelectorAll('[data-coras-cart-checkout]').forEach(button => {button.type = 'button'; button.removeAttribute('name');});
  }
  window.addEventListener('click',event => {
    const button = event.target.closest?.('[data-coras-cart-checkout]'), form = button?.closest('form[data-coras-cart]');
    if (!form) return;
    event.preventDefault(); event.stopImmediatePropagation(); submitCart(form,true);
  },true);
  window.addEventListener('submit',event => {
    const form = event.target;
    if (!form.matches?.('form[data-coras-cart]')) return;
    event.preventDefault(); event.stopImmediatePropagation(); submitCart(form,Boolean(event.submitter?.matches('[data-coras-cart-checkout]')));
  },true);
  window.addEventListener('pagehide',() => clearTimeout(redirectTimer));
  window.addEventListener('pageshow',() => {clearTimeout(redirectTimer); activeForm = null; setBusy(false);});
  document.addEventListener('visibilitychange',() => {if (!document.hidden && busy && activeForm) {setBusy(false); activeForm = null;}});
  document.addEventListener('shopify:section:load',event => init(event.target));
  window.UnchemedCommerce = Object.freeze({init,buildPayload:payload,validateCheckoutURL:checkoutURL,version:'2026-09-27.home-shop'});
  attribution();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(),{once:true}); else init();
})();


